import { ConfirmationPage } from './ConfirmationPage';
import { withConfirmationPage } from './withConfirmationPage';

const ConnectedConfirmationPage = withConfirmationPage(ConfirmationPage);

export { ConnectedConfirmationPage as ConfirmationPage };
